import { Loader2 } from "lucide-react";

import { Button } from "./ui/button";

const LoadingButton = () => {
  return (
    <Button
      disabled
      className="tw-w-full tw-font-semibold tw-mt-6 md:tw-mt-8 tw-text-sm tw-bg-[#00B5ED] tw-text-primary-foreground tw-shadow hover:tw-bg-[#00a3d5]"
    >
      <Loader2 className="tw-animate-spin" />
    </Button>
  );
};

export default LoadingButton;
